'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');



var _DetailsToInvoiceInputField = require('./DetailsToInvoiceInputField');var _DetailsToInvoiceInputField2 = _interopRequireDefault(_DetailsToInvoiceInputField);

var _paymentCalculation = require('../../helpers/paymentCalculation');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _reduxFormValidators = require('../../helpers/reduxFormValidators');

var _DetailsToInvoiceForm = require('./DetailsToInvoiceForm.scss');var _DetailsToInvoiceForm2 = _interopRequireDefault(_DetailsToInvoiceForm);
var _packagesData = require('../../packagesData');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var DetailsToInvoiceForm = function (_Component) {_inherits(DetailsToInvoiceForm, _Component);function DetailsToInvoiceForm() {var _temp, _this, _ret;_classCallCheck(this, DetailsToInvoiceForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      showPreloader: false }, _this.














    renderPrice = function (price) {return '\u20AA' + (0, _beautifyNumber2.default)((0, _clearNumber2.default)(price)) + ' / ' + _this.props.translate('month');}, _this.

    renderIdField = function () {var _this$props =
      _this.props,translate = _this$props.translate,isAgent = _this$props.isAgent;
      var validateFunc = isAgent ? _reduxFormValidators.required : _reduxFormValidators.israelCardholderId;
      var translationPrefix = isAgent ? 'companyId' : 'id';

      return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'tax_id',
          component: _DetailsToInvoiceInputField2.default,
          errorMsg: '' + translate(translationPrefix + 'ErrorMessage'),
          iconName: 'id-card',
          validate: [validateFunc],
          placeholder: translate(translationPrefix).toString() }));


    }, _this.

    renderPublisherTitle = function () {var _this$props2 =
      _this.props,selectedPackage = _this$props2.selectedPackage,isAgent = _this$props2.isAgent;var
      period = selectedPackage.period,alternativePeriod = selectedPackage.alternativePeriod;
      var currentPeriod = (0, _get2.default)(_this.props.currentPackageData, 'period.' + period) ? period : alternativePeriod;

      var price = (0, _paymentCalculation.calculatePriceWithDiscount)(_this.props.currentPackageData, currentPeriod);var _ref =

      (0, _get2.default)(_this.props, 'currentPackageData.period[' + currentPeriod + ']') || {},highlight = _ref.highlight,autojump = _ref.autojump,top = _ref.top;
      var type = (0, _get2.default)(_this.props, 'currentPackageData.type');

      return (
        _react2.default.createElement(_components.PackageTitleForPayment, {
          properties: _react2.default.createElement('span', { className: _DetailsToInvoiceForm2.default.boldText }, _this.props.translate(type + 'Ad')),
          highlight:
          _react2.default.createElement(_components.HighlightTitleForPublisherPackage, {
            haveHighlight: highlight,
            haveAutojump: autojump,
            haveTopPromotion: top,
            topPromotionLabel: '' + _this.props.translate('topPromotionLabel') })


          // price={`₪${beautifyNumber(clearNumber(price))}`}
          , isAgent: isAgent }));


    }, _this.

    renderRealtorTitle = function () {var
      isAgent = _this.props.isAgent;
      var propertiesCount = (0, _get2.default)(_this.props, 'currentPackageData.properties');

      return (
        _react2.default.createElement(_components.PackageTitleForPayment, {
          properties: _react2.default.createElement('span', { className: _DetailsToInvoiceForm2.default.boldText }, _this.props.translate('plan') + ' ' + propertiesCount),
          isAgent: isAgent }));


    }, _this.

    renderLeadsTitle = function () {var _this$props3 =
      _this.props,isAgent = _this$props3.isAgent,selectedPackage = _this$props3.selectedPackage;var
      period = selectedPackage.period;
      var leadsCount = (0, _get2.default)(_this.props, 'currentPackageData.period.' + period + '.quantity');

      return (
        _react2.default.createElement(_components.PackageTitleForPayment, {
          properties: _react2.default.createElement('span', { className: _DetailsToInvoiceForm2.default.boldText },
            leadsCount + ' ' + _this.props.translate(leadsCount === 1 ? 'lead' : 'leads')),

          isAgent: isAgent }));


    }, _this.

    renderRocketTitle = function () {var
      isAgent = _this.props.isAgent;
      var perions = (0, _get2.default)(_this.props, 'currentPackageData.periods');

      return (
        _react2.default.createElement(_components.PackageTitleForPayment, {
          properties: _react2.default.createElement('span', { className: _DetailsToInvoiceForm2.default.boldText }, _this.props.translate('plan') + ' ' + perions),
          isAgent: isAgent }));


    }, _this.

    renderTitle = function () {var
      isAgent = _this.props.isAgent;
      var packageType = (0, _get2.default)(_this.props, 'currentPackageData.type');

      switch (packageType) {
        case _packagesData.packageTypes.LEADS:
          return _this.renderLeadsTitle();
        case _packagesData.packageTypes.ROCKET:
          return _this.renderRocketTitle();
        default:
          return isAgent ? _this.renderRealtorTitle() : _this.renderPublisherTitle();}

    }, _temp), _possibleConstructorReturn(_this, _ret);}DetailsToInvoiceForm.prototype.componentDidMount = function componentDidMount() {if (!this.props.isMobile) {document.body.style.overflow = 'hidden';}};DetailsToInvoiceForm.prototype.componentWillUnmount = function componentWillUnmount() {if (!this.props.isMobile) {document.body.style.overflow = '';}};DetailsToInvoiceForm.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,selectedPackage = _props.selectedPackage,isAgent = _props.isAgent;var
    period = selectedPackage.period,alternativePeriod = selectedPackage.alternativePeriod;
    var currentPeriod = (0, _get2.default)(this.props.currentPackageData, 'period.' + period) ? period : alternativePeriod;
    var packageType = (0, _get2.default)(this.props, 'currentPackageData.type');

    var couponType = (0, _get2.default)(this.props, 'discountCoupon.type');var _calculatePaymentAmou =
    (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(selectedPackage, this.props.packages, couponType),priceGrand = _calculatePaymentAmou.priceGrand;

    var timeUnits = isAgent ? 'months' : 'days';

    return (
      _react2.default.createElement('div', { className: _DetailsToInvoiceForm2.default.invoiceWrapper },
        _react2.default.createElement('div', { className: _DetailsToInvoiceForm2.default.headerWrapper },
          _react2.default.createElement(_components.OMTitle, {
            className: 'publishTitle',
            title: translate('purchaseSummary') }),


          this.renderTitle(),

          _react2.default.createElement('div', { className: _DetailsToInvoiceForm2.default.totalBlock },
            period !== _packagesData.periods.FOREVER &&
            _react2.default.createElement('div', null,
              translate(isAgent ? 'advertisingFor' : 'promotionFor'), '\xA0',
              currentPeriod, '\xA0',
              translate(packageType === _packagesData.packageTypes.ROCKET ? 'days' : timeUnits)),


            _react2.default.createElement('div', null,
              translate('totalInclude'), '\u20AA', priceGrand))),



        _react2.default.createElement('div', { className: _DetailsToInvoiceForm2.default.formWrapper },
          _react2.default.createElement(_components.OMTitle, {
            className: 'publishTitle',
            title: translate('detailsToInvoice') }),

          _react2.default.createElement('form', {
              onSubmit: this.props.handleSubmit(function (data) {
                _this2.setState({ showPreloader: true });
                _this2.props.onSubmit(data);
              }) },

            _react2.default.createElement(_reduxForm.Field, {
              name: 'invoice_name',
              component: _DetailsToInvoiceInputField2.default,
              errorMsg: '' + translate('nameErrorMessage'),
              iconName: 'user',
              validate: [_reduxFormValidators.required],
              placeholder: translate('nameForInvoice').toString() }),

            this.renderIdField(),
            _react2.default.createElement(_components.OMSubmitButton, {
              title: translate('continuePay'),
              activeSpinner: this.state.showPreloader,
              disabled: this.state.showPreloader })))));





  };return DetailsToInvoiceForm;}(_react.Component);


DetailsToInvoiceForm.propTypes = {
  selectedPackage: _propTypes2.default.object,
  currentPackageData: _propTypes2.default.object,
  discountCoupon: _propTypes2.default.object,
  packages: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  handleSubmit: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'details-to-invoice' })(
DetailsToInvoiceForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DetailsToInvoiceForm/DetailsToInvoiceForm.js
// module id = 2933
// module chunks = 0